<template>
   <div class="  is-fullheight sticky-sidebar" >
     <aside class="menu column  aside   is-fullheight" >
      <p class="menu-label">
        Knitting
      </p>
      <ul class="menu-list">
        
        <li style="">
          <a class="">General</a>
          <ul>
            <li @click="activeMenuLink = '/production/knitted-trims'"><router-link to="/production/knitted-trims"  :class="{'is-active':activeMenuLink === '/production/knitted-trims'}">Knitted Trims</router-link></li>
            <li v-if="user.user_ireland == 1" @click="activeMenuLink = '/reports/knitted-trims'"><router-link to="/reports/knitted-trims"  :class="{'is-active':activeMenuLink === '/reports/knitted-trims'}" >Knitted Trims Overview</router-link></li>
            
          </ul>
        </li>

        <li style="" v-if="user.user_ireland == 1">
          <a class="">Bobble Hats</a>
          <ul>
            <li @click="activeMenuLink = '/production/hats-incoming'"><router-link to="/production/hats-incoming"  :class="{'is-active':activeMenuLink === '/production/hats-incoming'}">New Orders</router-link></li>
            <li @click="activeMenuLink = '/production/hats-inprogress'"><router-link to="/production/hats-inprogress"  :class="{'is-active':activeMenuLink === '/production/hats-inprogress'}">In Progress Orders</router-link></li>
             <li @click="activeMenuLink = '/production/hats-completed'"><router-link to="/production/hats-completed"  :class="{'is-active':activeMenuLink === '/production/hats-completed'}">Completed</router-link></li>
            
            
          </ul>
        </li>

       
        
        
        
      </ul>
      
    </aside>

   </div>
</template>

<script>
import OrderMixin from "@/mixins/OrderMixin.js";

export default {
  name: 'SideBarKnit',
  components: {
  },
  mixins: [OrderMixin],
  data() {
    return { 
      activeMenuLink: null,
      user: {tasks: []},
     }
  },
  mounted() {
    //this.activeMenuLink = this.$route.path.substring(1)
    this.activeMenuLink = this.$route.path
    console.log(this.activeMenuLink)
  },
  created() {
		this.getAccessToken()
        .then(() => { 
           this.getUserProfile(1); // 1 for with_tasks

           
        });
	}
}

</script>



